// extracted by mini-css-extract-plugin
module.exports = {"component":"style_component__zfaSE","icon":"style_icon__CZtLb","custom-tooltip-position":"style_custom-tooltip-position__MUKkk"};